import sidebarDate from './sidebar-date';
import buildDropdown from './modules/dropdown';

export default () => {

  const s = {};
  const init = () => {
    s.root = document.getElementById('sidebar-league');
    if (!s.root) {
      return;
    }

    s.root.isBuilded = false;
    s.root.buildSidebar = () => {
      s.root.isBuilded = true;
      if (window.matchMedia('(min-width: 768px)').matches) {
        buildAccordion();

        setAccordionsStatus();
      } else {
        // サイドバーの中の要素で SP時にdropdownになる要素は各ページで一つのみなので、
        // 複数回回す必要なし
        buildDropdown(s.root, '.le-side-dropdown');
      }

      sidebarDate();
    }
  }

  // サイドバー全体の高さがブラウザの高さより大きい場合は全てのアコーディオンを閉じた状態に変更
  const setAccordionsStatus = () => {
    const wHeight = window.innerHeight;
    const hHeight = document.querySelector('.l-header').offsetHeight;
    const sEntityHeight =  s.root.firstElementChild.offsetHeight;
    // const sEntityOffsetTop =  s.root.firstElementChild.getBoundingClientRect().top;
    const accordions = s.root.querySelectorAll('.js-accordion');

    accordions.forEach(accordion => {
      const body = accordion.querySelector('.le-side__body');
      if ((wHeight - hHeight) < sEntityHeight) {
        accordion.classList.remove('is-open');
        accordionBodyCloseAction(body);
      } else {
        accordionBodyOpenAction(body);
      }
    })
  }

  const buildAccordion = () => {
    const accordions = s.root.querySelectorAll('.js-accordion');
    accordions.forEach(accordion => {
      bindClickAccordionAction(accordion);
    })
  }

  const bindClickAccordionAction = (accordion) => {
    const target = accordion.querySelector('header');
    const body = accordion.querySelector('.le-side__body');

    target.addEventListener('click', () => {
      const isOpen = accordion.classList.contains('is-open');
      if (isOpen) {
        accordion.classList.remove('is-open');
        accordionBodyCloseAction(body);
      } else {
        accordion.classList.add('is-open');
        accordionBodyOpenAction(body);
      }
    })
  }

  const accordionBodyOpenAction = (body) => {
    const entity = body.firstElementChild;
    const entityHeight = entity.offsetHeight;
    body.style.height = `${entityHeight}px`;
  }
  const accordionBodyCloseAction = (body) => {
    body.style.height = '0px';
  }

  init();

  return {}
}
